import { ReactNode } from "react";
import { DropdownOption } from "./dropdownOption";

interface DropdownOptionGroup<T extends string | number> {
    key: string;
    groupKey?: string;
    header: ReactNode;
    options: Array<DropdownOption<T>>;
}

// Prefer groupKey so filtering cannot erase group boundaries; fall back to legacy header markers.
export function groupDropdownOptions<T extends string | number>(
    options: Array<DropdownOption<T>>,
): Array<DropdownOptionGroup<T>> {
    const groups: Array<DropdownOptionGroup<T>> = [];
    options.forEach((option) => {
        const previous = groups[groups.length - 1];
        const startNewGroup =
            groups.length === 0 ||
            (option.groupKey != null
                ? previous.groupKey !== option.groupKey
                : !!option.groupHeader);
        if (startNewGroup) {
            groups.push({
                key: option.groupKey ?? option.key ?? String(option.value),
                groupKey: option.groupKey,
                header: option.groupHeader ?? option.groupKey ?? null,
                options: [],
            });
        }
        groups[groups.length - 1].options.push(option);
    });
    return groups;
}
